import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { BankAccount } from '../organization-bank-accounts.model';
import { MatButtonModule } from '@angular/material/button';
import { BankAccountFormatPipe } from '../pipes/bank-account-format.pipe';

@Component({
	selector: 'app-mass-bank-account-duplicate-dialog',
	standalone: true,
	imports: [MatDialogModule, MatButtonModule, BankAccountFormatPipe],
	template: `<h2 mat-dialog-title>Komunikat</h2>

		<mat-dialog-content>
			@for (type of ['assigned', 'unassigned']; track type) {
				@let accounts = type === 'assigned' ? assignedBankAccounts() : unassignedBankAccounts();
				@if (accounts?.length > 0) {
					@switch (type) {
						@case ('assigned') {
							Poniższe konta bankowe mają już przypisaną organizację:
						}
						@case ('unassigned') {
							Poniższe konta istnieją w systemie, ale nie mają jeszcze przypisanej organizacji:
						}
					}

					<strong>
						<ul>
							@for (bankAccount of accounts; track bankAccount.id) {
								<li>
									Numer konta: {{ bankAccount.number | bankAccountFormat }}
									@if (!!bankAccount.organization) {
										-> ID organizacji:
										{{ bankAccount.organization }}
									}
								</li>
							}
						</ul>
					</strong>

					@if (type === 'unassigned') {
						Czy chcesz teraz przypisać organizację do kont <b>bez przypisanej organizacji</b>?
					}
				}
			}
		</mat-dialog-content>

		<mat-dialog-actions align="end">
			@if (unassignedBankAccounts()?.length > 0) {
				<button mat-raised-button color="warn" (click)="onCancel()">Nie</button>
				<button mat-raised-button color="primary" (click)="onConfirm()">Tak</button>
			} @else {
				<button mat-raised-button color="primary" (click)="onCancel()">OK</button>
			}
		</mat-dialog-actions>`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MassBankAccountDuplicateDialogComponent implements OnInit {
	readonly bankAccounts: BankAccount[] = inject(MAT_DIALOG_DATA);

	readonly unassignedBankAccounts = signal<BankAccount[]>([]);
	readonly assignedBankAccounts = signal<BankAccount[]>([]);

	private readonly dialogRef = inject(MatDialogRef<MassBankAccountDuplicateDialogComponent>);

	ngOnInit(): void {
		const { assigned, unassigned } = this.partitionBankAccounts(this.bankAccounts);
		this.assignedBankAccounts.set(assigned);
		this.unassignedBankAccounts.set(unassigned);
	}

	onConfirm(): void {
		this.dialogRef.close(this.unassignedBankAccounts());
	}

	onCancel(): void {
		this.dialogRef.close();
	}

	private partitionBankAccounts(accounts: BankAccount[]): { assigned: BankAccount[]; unassigned: BankAccount[] } {
		return accounts.reduce(
			(acc, account) => {
				(!!account.organization ? acc.assigned : acc.unassigned).push(account);
				return acc;
			},
			{ assigned: [], unassigned: [] },
		);
	}
}
